export const URI_TAG_GROUP = 'template/module/tag/group';
